"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _arrayMove = _interopRequireDefault(require("array-move")),
    _Image = _interopRequireDefault(require("../../Image")),
    _Icon = _interopRequireDefault(require("../../Icon"));

require("../styles/_resource-members.scss");

var MAX_PREVIEW_MEMBERS_COUNT = 3,
    OWNER = "OWNER";

function ResourceMembers(a) {
  var b = a.members,
      c = a.imageSize,
      d = a.countSuffix,
      e = a.showCount,
      f = a.showOwnerBadge,
      g = a.onAddIconClick,
      h = a.darkMode,
      i = b.length,
      j = f ? b.findIndex(function (a) {
    var b = a.role;
    return b && b.name === OWNER;
  }) : -1,
      k = -1 < j ? (0, _arrayMove["default"])(b, j, 0).slice(0, MAX_PREVIEW_MEMBERS_COUNT).reverse() : b.slice(0, MAX_PREVIEW_MEMBERS_COUNT),
      l = "VIEWER".concat(1 === i ? "" : "S");
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("resource-members", {
      "resource-members--dark-mode": h
    })
  }, k.map(function (a, b) {
    var d = a.userId,
        e = a.teamId,
        g = a.name,
        j = a.firstName,
        k = a.lastName,
        l = a.imageUrl,
        m = a.role,
        n = g || "".concat(j, " ").concat(k),
        o = i > MAX_PREVIEW_MEMBERS_COUNT && 0 === b;
    return _react["default"].createElement("div", {
      key: d || e,
      className: (0, _classnames["default"])("resource-members__member", {
        "resource-members__member--with-more": o
      }, {
        "resource-members__member--dark-mode": h
      }),
      style: {
        zIndex: i - b
      }
    }, _react["default"].createElement(_Image["default"], {
      height: c,
      width: c,
      circular: !0,
      imageUrl: l,
      placeholderText: n,
      placeholderTextSize: 9,
      backgroundSize: "cover"
    }), f && m && m.name === OWNER ? _react["default"].createElement("div", {
      className: "resource-members__member__owner"
    }, _react["default"].createElement(_Icon["default"], {
      name: "owner",
      color: "goldenShiny",
      size: 12
    })) : null, o ? _react["default"].createElement("span", {
      className: "resource-members__member__quantity"
    }, "+".concat(i - 2)) : null);
  }), g ? _react["default"].createElement("div", {
    className: (0, _classnames["default"])("resource-members__member", "resource-members__member--add-icon", {
      "resource-members__member--dark-mode": h
    })
  }, _react["default"].createElement(_Image["default"], {
    height: c,
    width: c,
    circular: !0,
    defaultImageIcon: "addfat",
    defaultIconColour: "michael",
    backgroundSize: "cover",
    onClick: g
  })) : null, e ? _react["default"].createElement("span", {
    className: "resource-members__total"
  }, "".concat(i, " ").concat(d || l)) : null);
}

ResourceMembers.defaultProps = {
  imageSize: "20px"
};

var _default = (0, _react.memo)(ResourceMembers);

exports["default"] = _default;